(() => {
  const logo = document.querySelector('.cm-home-hero .hero-logo-image');
  if (!logo) return;

  let framePending = false;

  const update = () => {
    framePending = false;

    const scrollY = window.scrollY || window.pageYOffset || 0;
    const scrolled = scrollY >= 220;
    const mobile = window.matchMedia('(max-width: 749px)').matches;

    document.body.classList.toggle('hero-logo-top', !scrolled);
    document.body.classList.toggle('hero-logo-scrolled', scrolled);

    if (mobile) {
      logo.style.removeProperty('transform');
      return;
    }

    const progress = Math.min(scrollY / 320, 1);
    const scale = 1 - 0.72 * progress;
    const translateY = -140 * progress;
    logo.style.transform = `translateY(${translateY}px) scale(${scale})`;
  };

  const queueUpdate = () => {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate, { passive: true });
  queueUpdate();
})();
